import { render } from "./shipping-info.vue?vue&type=template&id=4bd06694&scoped=true"
const script = {}

import "./shipping-info.vue?vue&type=style&index=0&id=4bd06694&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.32_vue@3.5.29_typescript@5.9.3__webpack@5.106.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bd06694"]])

export default __exports__